module.exports = __webpack_public_path__ + "img/flag-CA.9ad493a3.png";